import React from 'react'
import * as styles from './Feedback.module.scss'
import Form from '../common/Form'
import { Link } from 'gatsby'
import { ArrowRightIcon } from '@atlas-co/icons'

const Feedback = () => {
  return (
    <div className={styles.section}>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <div className={styles.heading}>
              <h1>Feedback</h1>
              <p>
                If you've run into any issues or have suggestions for
                improvement, this is the best way to let us know. These messages
                go directly to a special engineering channel.
              </p>
            </div>
            <Form
              submitText={'Send feedback'}
              formName={'Feedback'}
              successMessage={
                'Thank you for your feedback! We appreciate your input and will review it shortly.'
              }
            />
          </div>
        </div>
        <div className={styles.rightSection}>
          <div>
            <h3>Resources</h3>
            <div className={styles.resources}>
              <Link to="/docs/">
                <div className={styles.resource}>
                  <div>
                    <h4>Documentation</h4>
                    <p>
                      Check out our documentation for detailed guides and
                      examples.
                    </p>
                  </div>
                  <ArrowRightIcon size={28} />
                </div>
              </Link>
              <Link to="/academy/">
                <div className={styles.resource}>
                  <div>
                    <h4>Atlas Academy</h4>
                    <p>
                      Explore our Atlas Academy for in-depth tutorials and
                      resources.
                    </p>
                  </div>
                  <ArrowRightIcon size={28} />
                </div>
              </Link>
              <Link to="/blueprints/">
                <div className={styles.resource}>
                  <div>
                    <h4>Blueprints</h4>
                    <p>
                      Discover our blueprints for step-by-step guides on using
                      Atlas.
                    </p>
                  </div>
                  <ArrowRightIcon size={28} />
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Feedback
